import BeforeAfter from "../components/BeforeAfter";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import InstagramGallery from "../components/InstagramGallery";
import Newsletter from "../components/Newsletter";
import RoutineGuide from "../components/RoutineGuide";
import Testimonials from "../components/Testimonials";

const Home = () => {
  return (
    <>
      <Hero />
      <Testimonials />
      <BeforeAfter />
      <RoutineGuide />
      <Newsletter />
      <InstagramGallery />
      <Footer />
    </>
  );
};

export default Home;
